import { Injectable} from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { UserLoginResponse } from 'src/app/login/login.model';
import { UserType } from 'src/app/user/user.model';
import { StorageService } from './storage.service';
import { LoginService } from 'src/app/login/login.service';

@Injectable({
    providedIn: "root"
  })
export class SessionService extends StorageService {

  constructor() {
    super();
   }

  private loggedIn = new ReplaySubject<Boolean>(1);
  public onLoggedInStateChange = this.loggedIn.asObservable();

  private updateLoginState(value: Boolean):void {
    this.loggedIn.next(value)
  };

  public setLocalStorageValue(loggedIn: Boolean,authInfo?: UserLoginResponse ) {
    this.updateLoginState(loggedIn);
    this.setItem('loggedIn', loggedIn.toString());

    if(authInfo) {
      this.setItem('authInfo', JSON.stringify(authInfo));
    } else{
      this.removeItem('authInfo');
    }
  }
  
  login(response: UserLoginResponse) {
    this.setLocalStorageValue(true,response);
  }

  logout() {
    this.setLocalStorageValue(false);
  }

  getLoginState() {
    let loggedIn = this.getItem('loggedIn');

    if(loggedIn && loggedIn === 'true') {
      this.updateLoginState(true);
    } else{
      this.updateLoginState(false);
    }
  }

  getAuthInfo():UserLoginResponse|null {
    let authInfoString :string = this.getItem('authInfo')!;

    if(authInfoString) {
      return JSON.parse(authInfoString);
    } else{
      return null;
    }
  }
  

  isAdminUser() {
    return this.getAuthInfo()?.user?.userType === UserType.ADMIN.id;
  }
}
